<mat-card class="main-container">
  <mat-card-header>
    <mat-card-title class="header-logo">
      <img src="/assets/images/logo.png" alt="biome-logo" />
    </mat-card-title>
    <mat-card-title>Username/Password recovery</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <br />
    @if (
      _resetPasswordService.resetPasswordStatus();
      as forgotCredentialsStatus
    ) {
      @if (
        forgotCredentialsStatus?.type !== "success" &&
        forgotCredentialsStatus?.type !== "info"
      ) {
        <form #ngForgetCredentialsForm="ngForm">
          <mat-form-field class="example-form-field">
            <mat-label>Email</mat-label>
            <input matInput [formControl]="email" type="email" />
            @if (
              (email.touched || ngForgetCredentialsForm.submitted) &&
              email.errors?.["email"]
            ) {
              <mat-error>Please enter a valid email address.</mat-error>
            }
            @if (
              (email.touched || ngForgetCredentialsForm.submitted) &&
              email.errors?.["required"]
            ) {
              <mat-error>Email is required.</mat-error>
            }
          </mat-form-field>
        </form>
      }
      <div
        [ngClass]="{
          'auth-error': forgotCredentialsStatus.type === 'error',
          'auth-success': forgotCredentialsStatus.type === 'success',
        }"
      >
        {{ forgotCredentialsStatus.message }}
        @if (forgotCredentialsStatus.type === "success") {
          Still need help? Contact the
          <a
            href="https://biome-analytics.atlassian.net/servicedesk/customer/portals"
            target="_blank"
            rel="noopener noreferrer"
            >Biome Support Portal</a
          >.
        }
      </div>
      <br />
      @if (
        forgotCredentialsStatus.type !== "success" &&
        forgotCredentialsStatus.type !== "info"
      ) {
        <div class="button-group">
          <button
            mat-raised-button
            data-ba-id="forgot-button"
            color="primary"
            (click)="onForgotUsername()"
            [disabled]="isBusy()"
          >
            <div class="text-container">
              @if (isBusy()) {
                <mat-spinner diameter="20"></mat-spinner>
              }
              @if (!isBusy()) {
                <span>Request username</span>
              }
              @if (isBusy()) {
                <span>Please wait...</span>
              }
            </div>
          </button>
          <button
            mat-raised-button
            data-ba-id="forgot-button"
            color="primary"
            (click)="onForgotPassword()"
            [disabled]="isBusy()"
          >
            <div class="text-container">
              @if (isBusy()) {
                <mat-spinner diameter="20"></mat-spinner>
              }
              @if (!isBusy()) {
                <span>Reset password</span>
              }
              @if (isBusy()) {
                <span>Please wait...</span>
              }
            </div>
          </button>
        </div>
        <div class="info-box">
          Please enter the email address associated with your account, then
          choose Reset password or Request username.
        </div>
      }
    }
  </mat-card-content>
</mat-card>
<ba-support-button />
